import { IState } from 'shared/store';

import { selectDailyrentOfferData } from './selectDailyrentOfferData';

export const selectDailyrentOfferRating = (state: IState) => {
  return selectDailyrentOfferData(state)?.rating;
};
